import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    wrapper: {
      position: 'relative',

      '&:hover': {
        '& $collapseButtonActionMenu': {
          display: 'block',
        },

        '& $root:not($isEmptySubmenuItem)': {
          backgroundColor: `${COLORS.neutral.darkGray}DD`,
        },
      },

      '&$contextMenuOpened': {
        '& $collapseButtonActionMenu': {
          display: 'block',
        },

        '& $root:not($isEmptySubmenuItem)': {
          backgroundColor: `${COLORS.neutral.darkGray}DD`,
        },
      },
    },
    contextMenuOpened: {},

    root: {
      justifyContent: 'flex-start',
      width: '100%',
      height: 38,
      padding: theme.spacing(0.5, 0.25, 0.5, 1),
      borderRadius: 4,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightRegular,
      color: COLORS.neutral.silver,

      '&:hover:not($isEmptySubmenuItem)': {
        backgroundColor: `${COLORS.neutral.darkGray}DD`,
      },

      '&$active': {
        backgroundColor: COLORS.neutral.darkGray,
        fontWeight: theme.typography.fontWeightMedium,

        '& $iconStart': {
          color: COLORS.neutral.lightGray,
        },
        '&$whiteIcon $iconStart': {
          color: COLORS.neutral.white,
        },
      },

      '&$whiteIcon': {
        '& $iconStart': {
          color: COLORS.neutral.white,
        },
      },
    },
    active: {},
    isEmptySubmenuItem: {
      cursor: 'default',
      color: COLORS.neutral.mediumGray,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      height: 32,
    },
    whiteIcon: {},

    label: {},
    startIcon: {
      color: COLORS.neutral.silver,
      fontSize: theme.typography.pxToRem(20),
      display: 'flex',
      justifyContent: 'center',
      marginRight: theme.spacing(1),
    },
    endIcon: {
      marginLeft: 'auto',
      marginRight: theme.spacing(1),
      alignSelf: 'center',
      color: '#697385',
    },
    iconStart: {
      color: COLORS.neutral.mediumGray,

      // HINT: we need to overcome specificity of ".MuiButton-iconSizeMedium > *:first-child"
      '&&': {
        fontSize: theme.typography.pxToRem(20),
      },
    },
    collapseButtonActionMenu: {
      display: 'none',
      position: 'absolute',
      right: 4,
      bottom: 5,
    },
  }),
  { name: 'SidebarButton' }
);
